import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

// Direct payment status update function - bypasses all other logic
export const updatePaymentStatusDirect = async (bookingId, newPaymentStatus) => {
  try {
    console.log('DIRECT PAYMENT UPDATE: Starting for booking:', bookingId, 'Status:', newPaymentStatus);
    
    const bookingRef = doc(db, 'bookings', bookingId);
    const currentDoc = await getDoc(bookingRef);
    
    if (!currentDoc.exists()) {
      console.log('DIRECT PAYMENT UPDATE: Booking not found in Firestore, trying localStorage fallback');
      
      // Fallback: Update localStorage directly
      try {
        const localBookings = JSON.parse(localStorage.getItem('userBookings') || '[]');
        const bookingIndex = localBookings.findIndex(b => b.id === bookingId);
        
        if (bookingIndex !== -1) {
          localBookings[bookingIndex] = {
            ...localBookings[bookingIndex],
            payment: newPaymentStatus,
            paymentUpdatedAt: new Date().toISOString(),
            lastModified: new Date().toISOString()
          };
          
          localStorage.setItem('userBookings', JSON.stringify(localBookings));
          console.log('DIRECT PAYMENT UPDATE: Successfully updated localStorage as fallback');
          return true;
        }
      } catch (localError) {
        console.error('DIRECT PAYMENT UPDATE: localStorage fallback failed:', localError);
      }
      
      throw new Error('Booking not found in Firestore - this may be a localStorage-only booking');
    }
    
    const currentData = currentDoc.data();
    console.log('DIRECT PAYMENT UPDATE: Current payment status:', currentData.payment);
    
    // Update ONLY the payment status
    const updateData = {
      payment: newPaymentStatus,
      paymentUpdatedAt: new Date().toISOString(),
      lastModified: new Date().toISOString()
    };
    
    console.log('DIRECT PAYMENT UPDATE: Updating with:', updateData);
    
    await updateDoc(bookingRef, updateData);
    
    // Verify the update
    const verifyDoc = await getDoc(bookingRef);
    const verifyData = verifyDoc.data();
    
    console.log('DIRECT PAYMENT UPDATE: Verification - payment status is now:', verifyData.payment);
    
    if (verifyData.payment !== newPaymentStatus) {
      throw new Error(`Payment status update failed. Expected: ${newPaymentStatus}, Got: ${verifyData.payment}`);
    }
    
    console.log('DIRECT PAYMENT UPDATE: SUCCESS!');
    return true;
    
  } catch (error) {
    console.error('DIRECT PAYMENT UPDATE: FAILED:', error);
    throw error;
  }
};
